var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"row",attrs:{"id":"featured-industries"}})
}
var staticRenderFns = []

export { render, staticRenderFns }